export interface Article {
  id: string;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  excerpt: string;
  content: string;
  author: string;
  publishDate: string;
  readTime: number;
  tags: string[];
  relatedGameIds: string[];
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '星界幻想曲新手入门完全指南：从零开始的冒险之旅',
    slug: 'star-fantasy-beginner-guide',
    category: '游戏攻略',
    categorySlug: 'guide',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20fantasy%20game%20guide%20banner%20with%20magical%20world%20map%20and%20character%20illustrations%2C%20warm%20golden%20lighting%2C%20informative%20and%20inviting%20atmosphere%2C%20game%20guide%20header%20image%20style&width=1200&height=630&seq=article-cover-01&orientation=landscape',
    excerpt: '刚踏入星界幻想曲的世界感到迷茫？本指南从角色创建到装备获取，手把手教你快速上手这款热门MMORPG，助你少走弯路。',
    content: `<h2>一、角色创建与职业选择</h2>
<p>星界幻想曲目前提供了<strong>六大职业</strong>供玩家选择：剑士、法师、弓箭手、刺客、牧师和召唤师。每个职业都有独特的技能树和玩法风格。</p>
<p>对于新手玩家，我们强烈推荐<strong>剑士</strong>和<strong>牧师</strong>两个职业。剑士拥有较高的生存能力和稳定的输出，适合熟悉游戏基础操作；牧师作为团队核心，在任何副本中都备受欢迎，且操作相对简单。</p>
<h3>职业推荐指数</h3>
<p>剑士：★★★★★（推荐新手）<br/>牧师：★★★★★（推荐新手）<br/>法师：★★★★☆<br/>弓箭手：★★★★☆<br/>刺客：★★★☆☆<br/>召唤师：★★★☆☆</p>
<h2>二、前期升级路线</h2>
<p>1-30级是游戏的<strong>新手引导阶段</strong>，跟随主线任务即可快速升级。30级之后，建议按照以下路线提升等级：</p>
<p>主线任务 → 每日副本 → 公会任务 → 野外挂机 → 活动副本</p>
<p>特别注意：<strong>每日副本</strong>的经验奖励非常丰厚，每天务必完成。建议组队进行，经验加成可达到150%。</p>
<h2>三、装备获取与强化</h2>
<p>装备是提升战斗力的核心要素。以下是各阶段装备的获取途径：</p>
<p><strong>初期（1-50级）：</strong>主线任务赠送 + 副本掉落<br/><strong>中期（50-80级）：</strong>公会贡献兑换 + 世界Boss掉落<br/><strong>后期（80级以上）：</strong>团队副本 + 制造系统</p>
<p>强化装备时，建议优先强化<strong>武器</strong>和<strong>防具</strong>，这两者对战力的提升最为显著。</p>`,
    author: '游戏达人小王',
    publishDate: '2026-08-01',
    readTime: 8,
    tags: ['新手攻略', '星界幻想曲', 'MMORPG'],
    relatedGameIds: ['game-1'],
  },
  {
    id: 'article-2',
    title: '2026年最值得期待的十款h游戏大作盘点',
    slug: '2026-most-anticipated-games',
    category: '游戏资讯',
    categorySlug: 'news',
    coverImage: 'https://readdy.ai/api/search-image?query=Collage%20style%20banner%20of%20upcoming%20game%20releases%20in%202026%2C%20various%20game%20characters%20and%20scenes%2C%20exciting%20atmosphere%2C%20warm%20vibrant%20colors%2C%20promotional%20game%20art%20style&width=1200&height=630&seq=article-cover-02&orientation=landscape',
    excerpt: '2026年游戏界精彩纷呈，多款备受期待的大作即将上线。我们为你整理了十款不容错过的h游戏，每一款都值得你投入时间。',
    content: `<h2>2026年度游戏前瞻</h2>
<p>2026年是游戏界的丰收之年，众多顶级开发商纷纷推出力作。无论你喜欢什么类型的游戏，今年都能找到心仪的作品。以下是我们精选的<strong>十款最值得期待的游戏</strong>。</p>
<h2>TOP 1：末日求生：废土</h2>
<p>这款硬核生存游戏在上线首周就获得了<strong>4.9分</strong>的超高评价。凭借真实的生存机制和丰富的建造系统，它重新定义了生存类游戏的标准。</p>
<h3>亮点特色</h3>
<p>- 真实物理引擎，每个物品都有重量和耐久度<br/>- 动态天气系统，影响生存策略<br/>- 深度剧情，每个NPC都有自己的故事<br/>- 多人合作模式，与朋友共建避难所</p>
<h2>TOP 2：星界幻想曲</h2>
<p>这款二次元MMORPG以其<strong>精美的画面</strong>和<strong>丰富的社交系统</strong>赢得了大量玩家的心。游戏上线两个月，注册用户已突破500万。</p>`,
    author: 'H游资讯站',
    publishDate: '2026-08-05',
    readTime: 10,
    tags: ['游戏排行', '2026新游', '推荐'],
    relatedGameIds: ['game-6', 'game-1'],
  },
  {
    id: 'article-3',
    title: '暗影突袭：重生 - 全Boss战攻略与隐藏要素揭秘',
    slug: 'shadow-strike-boss-guide',
    category: '游戏攻略',
    categorySlug: 'guide',
    coverImage: 'https://readdy.ai/api/search-image?query=Cyberpunk%20boss%20battle%20guide%20banner%20with%20silhouetted%20figure%20facing%20giant%20mechanical%20enemy%2C%20neon%20orange%20and%20red%20lighting%2C%20dramatic%20action%20scene%2C%20game%20guide%20header%20style&width=1200&height=630&seq=article-cover-03&orientation=landscape',
    excerpt: '暗影突袭中的每一个Boss都有独特的机制和弱点。本攻略详细解析全部12个Boss的打法策略，并揭示游戏中隐藏的彩蛋和秘密区域。',
    content: `<h2>Boss战总览</h2>
<p>暗影突袭：重生共有<strong>12个主线Boss</strong>和<strong>4个隐藏Boss</strong>。每个Boss都有三个阶段，血量每减少三分之一就会进入新阶段，攻击模式也会相应变化。</p>
<h2>第一章Boss：机械守卫</h2>
<p>作为新手遇到的第一个真正挑战，机械守卫主要考验玩家的<strong>闪避</strong>和<strong>格挡</strong>基本功。</p>
<h3>攻击模式</h3>
<p><strong>第一阶段：</strong>近战锤击（可格挡）+ 远程激光（需闪避）<br/><strong>第二阶段：</strong>增加旋转攻击，范围广但速度慢<br/><strong>第三阶段：</strong>召唤无人机辅助攻击，优先清理无人机</p>
<h3>推荐打法</h3>
<p>使用<strong>电磁手雷</strong>可以短暂瘫痪机械守卫，创造输出窗口。建议携带至少3颗电磁手雷进入战斗。</p>
<h2>隐藏要素</h2>
<p>在第三章的地下水道区域，有一面看似普通的墙壁可以通过<strong>连续攻击5次</strong>打破，里面藏着一把传说级武器「暗影之刃」。</p>`,
    author: '攻略组-阿杰',
    publishDate: '2026-07-28',
    readTime: 15,
    tags: ['Boss攻略', '暗影突袭', '隐藏要素'],
    relatedGameIds: ['game-2'],
  },
  {
    id: 'article-4',
    title: '恋爱绮谭全角色攻略路线详解：找到你的专属结局',
    slug: 'love-romance-all-routes',
    category: '游戏攻略',
    categorySlug: 'guide',
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20visual%20novel%20guide%20banner%20with%20multiple%20anime%20character%20portraits%20arranged%20in%20a%20row%2C%20soft%20pink%20and%20golden%20lighting%2C%20cherry%20blossom%20petals%2C%20gentle%20atmosphere&width=1200&height=630&seq=article-cover-04&orientation=landscape',
    excerpt: '恋爱绮谭拥有5条主线感情路线和2条隐藏路线。本文详细解析每个角色的好感度获取方式和关键选择节点，帮你达成心仪结局。',
    content: `<h2>角色路线概览</h2>
<p>恋爱绮谭共有<strong>5位可攻略角色</strong>，每位角色都有2-3个结局（好结局、普通结局、隐藏结局）。此外还有<strong>2条隐藏路线</strong>需要满足特殊条件才能解锁。</p>
<h2>角色一：小樱（青梅竹马）</h2>
<p>作为游戏的第一女主，小樱的路线相对<strong>最容易</strong>达成。关键选择点在第三章和第六章。</p>
<h3>好感度关键事件</h3>
<p>- 第一章：选择「去公园散步」+5好感<br/>- 第三章：选择「握住她的手」+10好感（关键选项）<br/>- 第五章：送她「樱花发夹」+8好感<br/>- 第六章：选择「说出真心话」解锁隐藏结局</p>`,
    author: '恋爱游戏研究所',
    publishDate: '2026-07-20',
    readTime: 12,
    tags: ['攻略', '恋爱绮谭', '结局'],
    relatedGameIds: ['game-3'],
  },
  {
    id: 'article-5',
    title: '手机h游戏推荐：2026年最佳移动端游戏合集',
    slug: 'best-mobile-games-2026',
    category: '游戏推荐',
    categorySlug: 'recommendation',
    coverImage: 'https://readdy.ai/api/search-image?query=Mobile%20gaming%20banner%20with%20smartphone%20displaying%20various%20colorful%20game%20screens%2C%20surrounded%20by%20game%20icons%2C%20warm%20and%20vibrant%20atmosphere%2C%20modern%20flat%20illustration%20style&width=1200&height=630&seq=article-cover-05&orientation=landscape',
    excerpt: '手机游戏越来越精彩，我们为你精选了10款2026年最值得玩的移动端h游戏，涵盖RPG、策略、休闲等多种类型，随时随地享受游戏乐趣。',
    content: `<h2>移动游戏新时代</h2>
<p>随着手机性能的不断提升，移动端游戏的品质已经达到了<strong>前所未有的高度</strong>。2026年，多款顶级手游在画面、玩法和剧情上都堪比端游水准。</p>
<h2>精选推荐清单</h2>
<h3>1. 恋爱绮谭</h3>
<p>精美的二次元画风和全语音剧情，在手机上体验沉浸式的恋爱故事。支持<strong>离线游玩</strong>，通勤路上的最佳伴侣。</p>
<h3>2. 星界幻想曲</h3>
<p>移动端完美适配的MMORPG，<strong>跨平台数据互通</strong>，在家用PC、出门用手机，无缝衔接你的冒险之旅。</p>
<h3>3. 海岛物语</h3>
<p>轻松治愈的模拟经营游戏，<strong>碎片时间</strong>的最佳选择。种种田、钓钓鱼，享受悠闲的游戏时光。</p>`,
    author: 'H游资讯站',
    publishDate: '2026-07-15',
    readTime: 6,
    tags: ['手机游戏', '推荐', '移动端'],
    relatedGameIds: ['game-3', 'game-1', 'game-9'],
  },
  {
    id: 'article-6',
    title: '地下城编年史深度评测：Roguelike与策略的完美融合',
    slug: 'dungeon-chronicles-review',
    category: '游戏评测',
    categorySlug: 'review',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20dungeon%20game%20review%20banner%20with%20detailed%20character%20party%20exploring%20ancient%20ruins%2C%20torch%20light%20illuminating%20treasure%2C%20warm%20amber%20glow%2C%20professional%20game%20review%20header%20style&width=1200&height=630&seq=article-cover-06&orientation=landscape',
    excerpt: '地下城编年史将回合制策略与Roguelike元素结合，创造了独特的游戏体验。本文从画面、玩法、剧情等多维度深度评测这款热门作品。',
    content: `<h2>总体评分：9.2/10</h2>
<p>地下城编年史是一款让人<strong>欲罢不能</strong>的策略Roguelike游戏。每次进入地下城都是全新的挑战，随机生成的地图、怪物和装备让游戏拥有极高的重玩价值。</p>
<h2>画面表现：9/10</h2>
<p>游戏采用了<strong>手绘风格</strong>的美术设计，每个角色和怪物都经过精心绘制。地牢中的光影效果尤为出色，火炬的光照在石壁上的效果非常真实。</p>
<h2>玩法系统：9.5/10</h2>
<p>游戏的<strong>核心战斗系统</strong>基于回合制策略，但加入了独特的位置机制和元素反应系统。不同职业之间的技能配合能够产生意想不到的效果。</p>`,
    author: '评测编辑-老猫',
    publishDate: '2026-06-30',
    readTime: 8,
    tags: ['评测', '地下城编年史', 'Roguelike'],
    relatedGameIds: ['game-12'],
  },
];

export const getArticleBySlug = (slug: string): Article | undefined => articles.find((a) => a.slug === slug);
export const getArticleById = (id: string): Article | undefined => articles.find((a) => a.id === id);
export const getArticlesByCategory = (categorySlug: string): Article[] => articles.filter((a) => a.categorySlug === categorySlug);
export const getRelatedArticles = (articleId: string, count: number = 3): Article[] => {
  const current = articles.find((a) => a.id === articleId);
  if (!current) return [];
  return articles
    .filter((a) => a.id !== articleId && a.categorySlug === current.categorySlug)
    .slice(0, count);
};